export interface FeatureFlags {
  onboarding: boolean // Sign Up link on login → /onboarding
  regulatoryOperatorKey: string // backend key filtered from operator lists (ceind / celao / …)
  // Add new flags here — TypeScript will error on any country config missing a flag
}

const configs: Record<string, FeatureFlags> = {
  IN: {
    onboarding: false,
    regulatoryOperatorKey: 'ceind',
  },
  LA: {
    onboarding: true,
    regulatoryOperatorKey: 'celao',
  },
}

const country = (process.env.REACT_APP_COUNTRY || 'IN').toUpperCase()

/** Build-time feature flags resolved from REACT_APP_COUNTRY. Import directly — no hook needed. */
export const featureFlags: FeatureFlags = configs[country] ?? configs['IN']

/** ISO country code of the current build (e.g. "IN", "LA") */
export const currentCountry: string = country

/** Backend operator key for the regulatory authority in this build (e.g. "ceind", "celao"). */
export const REGULATORY_OPERATOR_KEY: string = featureFlags.regulatoryOperatorKey
